// Filters of the river list (RiverList.vue, RiverFilterPanel.vue, RiverFilterBar.vue). The criteria object is the one
// saved in the user's profile: { regions, classes, levels, isLiked, freeAccessOnly, dangersOnly }.

// Level filter values are sections.level_status, shown with the brand's level markers (LevelMarker.vue,
// docs/BRAND.md): bas / bon / haut. An unknown level has no marker.
export const LEVEL_FILTERS = [
  { value: "low", label: "Bas" },
  { value: "recommended", label: "Bon" },
  { value: "high", label: "Haut" },
  { value: "unknown", label: "Inconnu" },
];

export const TOGGLE_FILTERS = [
  { key: "isLiked", label: "Mes favoris", shortLabel: "Favoris", icon: "mdi-heart-outline", color: "gold-text" },
  { key: "dangersOnly", label: "Avec dangers actifs", shortLabel: "Dangers actifs", icon: "mdi-alert-outline", color: "danger" },
  { key: "freeAccessOnly", label: "Accès gratuit", shortLabel: "Accès gratuit", icon: "mdi-lock-open-outline", color: "primary" },
];

export function emptyCriteria() {
  return { regions: [], classes: [], levels: [], isLiked: false, freeAccessOnly: false, dangersOnly: false };
}

// One removable chip per active filter, in the order of the panel. remove(criteria) clears that filter.
export function activeFilters(criteria) {
  if (!criteria) return [];
  const chips = [];
  TOGGLE_FILTERS.forEach(({ key, shortLabel }) => {
    if (criteria[key]) chips.push({ id: key, label: shortLabel, remove: (c) => (c[key] = false) });
  });
  (criteria.levels || []).forEach((value) => {
    const level = LEVEL_FILTERS.find((item) => item.value === value);
    chips.push({
      id: `level-${value}`,
      label: `Niveau ${(level ? level.label : value).toLowerCase()}`,
      remove: (c) => (c.levels = c.levels.filter((item) => item !== value)),
    });
  });
  (criteria.classes || []).forEach((value) => {
    chips.push({ id: `class-${value}`, label: value, remove: (c) => (c.classes = c.classes.filter((item) => item !== value)) });
  });
  (criteria.regions || []).forEach((value) => {
    chips.push({ id: `region-${value}`, label: value, remove: (c) => (c.regions = c.regions.filter((item) => item !== value)) });
  });
  return chips;
}

// Empties every filter in place (the criteria object is watched deeply and saved by RiverList.vue)
export function clearCriteria(criteria) {
  Object.assign(criteria, emptyCriteria());
}

// Number of sections per region, for the counts next to each region
export function countByRegion(sections) {
  const counts = {};
  (sections || []).forEach((section) => {
    if (section && section.region) counts[section.region] = (counts[section.region] || 0) + 1;
  });
  return counts;
}

// "12 sections", "1 section", "Aucune section"
export function sectionCountLabel(count) {
  if (!count) return "Aucune section";
  return `${count} section${count > 1 ? "s" : ""}`;
}
